// extracted by mini-css-extract-plugin
module.exports = {"wrap":"StoreAdd_wrap__DBkba"};